/** A path on this site, or "". `/\evil.example` starts with "/" too, and the
 * browser reads the backslash as a slash: only a URL that resolves to our own
 * origin is let through (MK42-5819). */
export function safeNext(next: string): string {
  if (!next.startsWith('/') || next.startsWith('//') || next.includes('\\')) return '';
  try {
    const u = new URL(next, location.origin);
    return u.origin === location.origin ? u.pathname + u.search + u.hash : '';
  } catch {
    return '';
  }
}
